import { render, staticRenderFns } from "./DhmeManualImportCreateObjectDialog.vue?vue&type=template&id=c38a38ca&scoped=true"
import script from "./DhmeManualImportCreateObjectDialog.vue?vue&type=script&lang=js"
export * from "./DhmeManualImportCreateObjectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38a38ca",
  null
  
)

export default component.exports